import React from 'react';
import BaseTile from '../../../components/Tile/BaseTile';
import { useOrphanObjectsKpi } from './hooks/useOrphanObjectsKpi';

const Stat = ({ label, value }) => (
  <div className="flex flex-col items-center">
    <div className="text-xs text-gray-500">{label}</div>
    <div className="text-lg font-semibold">{value}</div>
  </div>
);

const OrphanObjects = ({ activeFile }) => {
  const { data, loading, error } = useOrphanObjectsKpi(activeFile);

  const total = data?.total_objects ?? 0;
  const orphan = data?.orphan_objects ?? 0;
  const ratePct = total > 0 ? ((data.orphan_ratio || 0) * 100).toFixed(2) : '0.00';

  return (
    <BaseTile title="Objects Without Referenced Events" loading={loading} error={error} minHeight="sm" padding="default">
      <div className="h-full flex flex-col items-center justify-center gap-4">
        <div className="text-4xl font-extrabold text-orange-600">{orphan}</div>
        <div className="text-sm text-gray-600">objects never referenced in any event</div>
        <div className="flex gap-6">
          <Stat label="Total Objects" value={total} />
          <Stat label="Orphan %" value={`${ratePct}%`} />
        </div>
      </div>
    </BaseTile>
  );
};

export default OrphanObjects;
